<svg
  viewBox="0 0 24 23"
  xmlns="http://www.w3.org/2000/svg"
  id="heartSvg"
>
  <path
    d="M12.0637 2.3074C14.8164 -0.164086 19.0703 -0.0820547 21.7223 2.57459C24.3731 5.2324 24.4645 9.46521 21.9988 12.2261L12.0613 22.1777L2.12618 12.2261C-0.339446 9.46521 -0.246868 5.22537 2.40274 2.57459C5.05704 -0.0785391 9.30274 -0.167602 12.0637 2.3074Z"
  />
</svg>
